import { render, staticRenderFns } from "./MedicineCard.vue?vue&type=template&id=98e9cf7a&scoped=true"
import script from "./MedicineCard.vue?vue&type=script&lang=js"
export * from "./MedicineCard.vue?vue&type=script&lang=js"
import style0 from "./MedicineCard.vue?vue&type=style&index=0&id=98e9cf7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e9cf7a",
  null
  
)

export default component.exports